<template>
  <div class="template-picker" v-click-outside="close">
    <button
      type="button"
      class="template-btn"
      :aria-expanded="open ? 'true' : 'false'"
      @click="open = !open"
    >
      Templates <span class="chev" aria-hidden="true">▾</span>
    </button>
    <div v-if="open" class="template-menu" role="menu">
      <button
        v-for="t in templates"
        :key="t.key"
        type="button"
        class="template-item"
        role="menuitem"
        :title="t.description"
        @click="applyTemplate(t.key)"
      >
        {{ t.title }}
      </button>
    </div>
  </div>
</template>

<script>
import { TEMPLATES } from '@/lib/parentingSchedule/rotationTemplates.js'

// Small click-outside directive to close the menu when the user clicks elsewhere.
const clickOutside = {
  bind(el, binding) {
    el._clickOutsideHandler = (e) => {
      if (!el.contains(e.target)) binding.value(e)
    }
    document.addEventListener('click', el._clickOutsideHandler)
  },
  unbind(el) {
    document.removeEventListener('click', el._clickOutsideHandler)
  },
}

export default {
  name: 'RotationTemplateMenu',
  directives: { 'click-outside': clickOutside },
  data() {
    return { open: false, templates: TEMPLATES }
  },
  methods: {
    close() { this.open = false },
    applyTemplate(key) {
      const t = this.templates.find((x) => x.key === key)
      if (!t) return
      // Emit the raw template config; parent decides whether to confirm-before-apply.
      this.$emit('apply', { key: t.key, title: t.title, config: t.apply() })
      this.open = false
    },
  },
}
</script>

<style scoped>
.template-picker { position: relative; display: inline-block; }
.template-btn {
  background: #34555f;
  color: #fff;
  border: 1px solid #34555f;
  border-radius: 6px;
  padding: 0.45rem 0.9rem;
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  transition: background 0.15s, border-color 0.15s;
}
.template-btn:hover { background: #244047; border-color: #244047; }
.chev { font-size: 0.7rem; }

.template-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 20;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  min-width: 220px;
  padding: 0.3rem 0;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
}
.template-item {
  background: transparent;
  border: none;
  color: #1e293b;
  font-family: inherit;
  font-size: 0.85rem;
  padding: 0.5rem 0.9rem;
  cursor: pointer;
  text-align: left;
  transition: background 0.12s;
}
.template-item:hover { background: #3f6772; color: #fff; }
</style>
